import {ObjectComboMapping} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {Box, Modal, ModalProps} from "@mantine/core";
import {MouseEvent, useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {useObjectComboMappingAction} from "../../menu/ObjectComboMappingActionMenu/useObjectComboMappingAction";
import {EntityActionGroup} from "../../group/EntityActionGroup/EntityActionGroup";
import {BaseObjectComboMappingDataTable, BaseObjectComboMappingDataTableProps} from "./BaseObjectComboMappingDataTable";

export type ObjectComboMappingDataTableProps = Omit<BaseObjectComboMappingDataTableProps, 'renderActions'>

export const ObjectComboMappingDataTable = (props: ObjectComboMappingDataTableProps) => {
  const {
    ...rest
  } = props

  const navigate = useNavigate()

  const {
    onObjectComboMappingActionClick
  } = useObjectComboMappingAction()

  const onViewActionClick = useCallback((e: MouseEvent<HTMLButtonElement>, record: ObjectComboMapping) => {
    e.stopPropagation()
    navigate(`/object-combo-mappings/profile?id=${record.id}`)
  }, [navigate])

  const onEditActionClick = useCallback((e: MouseEvent<HTMLButtonElement>, record: ObjectComboMapping) => {
    e.stopPropagation()
    onObjectComboMappingActionClick(record, 'EDIT')
  }, [onObjectComboMappingActionClick])

  const onDeleteActionClick = useCallback((e: MouseEvent<HTMLButtonElement>, record: ObjectComboMapping) => {
    e.stopPropagation()
    onObjectComboMappingActionClick(record, 'DELETE')
  }, [onObjectComboMappingActionClick])

  const renderActions = useCallback((record: ObjectComboMapping, index: number) => {
    return (
      <EntityActionGroup
        permissionPrefix={"objectmapping"}
        onViewActionClick={(e) => onViewActionClick(e, record)}
        onEditActionClick={(e) => onEditActionClick(e, record)}
        onDeleteActionClick={(e) => onDeleteActionClick(e, record)}
      />
    )
  }, [onEditActionClick, onViewActionClick, onDeleteActionClick])

  return (
    <BaseObjectComboMappingDataTable
      {...rest}
      renderActions={renderActions}
    />
  )
}

export type ObjectComboMappingDataTableModalProps = Omit<ModalProps, "onSubmit"> & {
  dataTable: Omit<ObjectComboMappingDataTableProps, 'recordsPerPageOptions'>
}

export const ObjectComboMappingDataTableModal = (props: ObjectComboMappingDataTableModalProps) => {
  const {t} = useTranslation(["common"]);

  const {
    title = t<string>("common.entity.objectcombomapping.plural", "Object Combo Mappings"),
    dataTable,
    ...rest
  } = props;

  return (
    <Modal {...rest} title={title}>
      <Box>
        <ObjectComboMappingDataTable
          {...dataTable}
          recordsPerPageOptions={[5]}/>
      </Box>
    </Modal>
  );
};
